import {WixSdk} from '@wix/js-sdk-wrapper';

export const getLocale = () => {
  return WixSdk.Utils.getLocale();
};
